/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from '../../../state'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { EventDetails } from './Login'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import { useI18n } from '@shopify/react-i18n'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

const getPositionName = (positionId) => {
  switch (positionId) {
    case 1:
      return 'Goalie'
    case 2:
      return 'Defense'
    case 3:
      return 'Forward'
    case 4:
      return 'Skater'
  }
}

export const RegistrationSubmitted = observer(({ isDarkMode }) => {
  const {
    registrationInvite: {
      state: { submittedInfo, eventInfo },
    },
  } = useMobxStore()
  const history = useHistory()

  const [i18n] = useI18n()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
        color: ${isDarkMode ? colors.WHITE : colors.BLACK};
      `}
    >
      <h1
        css={css`
          text-align: center;
          margin-top: 32px;
          font-size: 45px;
          font-weight: 700;
          font-family: ${isCanlan
            ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
            : 'Rift, Arial, Helvetica, sans-serif'};
        `}
      >
        {submittedInfo?.forcePayment
          ? 'Almost Done!'
          : 'Registration Submitted'}
      </h1>

      {submittedInfo?.forcePayment && (
        <div
          css={css`
            margin-top: 16px;
            max-width: 500px;
            align-self: center;

            p {
              text-align: center;
            }
          `}
        >
          <p>
            Now you need to pay the deposit amount in order to confirm your team
            registration.
          </p>
        </div>
      )}

      <div
        css={css`
          background-color: ${isDarkMode ? '#33363B' : '#f5f5f5'};
          padding: 16px;
          border-radius: 8px;
          margin: 32px 0;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            margin-bottom: 16px;
          `}
        >
          {submittedInfo?.teamImageUrl && (
            <img
              src={submittedInfo?.teamImageUrl}
              css={css`
                width: 36px;
                height: 36px;
                margin-right: 8px;
              `}
            />
          )}
          {submittedInfo?.teamName && (
            <p
              css={css`
                font-family: ${isCanlan
                  ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                  : 'Rift, Arial, Helvetica, sans-serif'};
                font-weight: 700;
                font-size: 36px;
                color: ${isDarkMode ? 'white' : '#27303e'};
              `}
            >
              {submittedInfo?.teamName}
            </p>
          )}
        </div>
        <EventDetails label='Competition' value={eventInfo?.name} />
        {submittedInfo?.divisionName && (
          <EventDetails label='Division' value={submittedInfo.divisionName} />
        )}
        {typeof submittedInfo?.deposit === 'number' &&
          !submittedInfo?.singlePayment && (
            <EventDetails
              label='Deposit'
              value={i18n.formatCurrency(submittedInfo.deposit, {
                currency: submittedInfo?.currency?.name,
                form: 'explicit',
              })}
            />
          )}
        {submittedInfo?.costPerTeam && (
          <EventDetails
            label={
              submittedInfo?.singlePayment
                ? 'Registration Cost'
                : 'Cost Per Team'
            }
            value={i18n.formatCurrency(submittedInfo.costPerTeam, {
              currency: submittedInfo?.currency?.name,
              form: 'explicit',
            })}
          />
        )}

        {submittedInfo?.firstName && (
          <EventDetails
            label='Player'
            value={submittedInfo?.firstName + ' ' + submittedInfo?.lastName}
          />
        )}
        {submittedInfo?.position && (
          <EventDetails
            label='Position'
            value={getPositionName(submittedInfo?.position)}
          />
        )}
        {submittedInfo?.number && (
          <EventDetails label='Number' value={submittedInfo?.number} />
        )}
        <p
          css={css`
            font-size: 12px;
          `}
        >
          (Applicable taxes will be applied to all payments)
        </p>
      </div>

      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        {!submittedInfo?.forcePayment && !submittedInfo.singlePayment && (
          <Link
            to={ROUTES.HOME}
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              margin-right: 8px;
              flex: 1;
              height: 40px;
              border: 2px solid #3f4753;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              color: ${isDarkMode ? 'white' : colors.HEADER};
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            BACK TO HOME
          </Link>
        )}
        {submittedInfo.singlePayment && (
          <Link
            to={`${ROUTES.REGISTRATION_PAYMENT}?divisionId=${submittedInfo.divisionId}&teamId=${submittedInfo.teamId}`}
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              color: white;
              flex: 1;
              height: 40px;
              background: ${colors.DEFAULT_FLAIR};
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            PAY{' '}
            {i18n.formatCurrency(submittedInfo.costPerTeam, {
              currency: submittedInfo?.currency?.name,
              form: 'explicit',
            })}
          </Link>
        )}
        {!submittedInfo.firstName && Number(submittedInfo.deposit) > 0 && (
          <Link
            to={`${ROUTES.REGISTRATION_PAYMENT}?divisionId=${submittedInfo.divisionId}&teamId=${submittedInfo.teamId}`}
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              margin-left: 8px;
              color: white;
              flex: 1;
              height: 40px;
              background: ${colors.DEFAULT_FLAIR};
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            {submittedInfo?.forcePayment ? 'PAY DEPOSIT NOW' : 'PAY DEPOSIT'}
          </Link>
        )}
      </div>

      {submittedInfo?.billingInfo &&
        submittedInfo?.billingInfo.length > 0 &&
        !submittedInfo.singlePayment && (
          <>
            <div
              css={css`
                margin-top: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              `}
            >
              <p
                css={css`
                  font-family: ${isCanlan
                    ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                    : 'Rift, Arial, Helvetica, sans-serif'};
                  font-weight: 700;
                  font-size: 28px;
                  text-align: center;
                  color: ${isDarkMode ? colors.WHITE : '#27303e'};
                `}
              >
                Payment Schedule (Installments)
              </p>
              <div
                css={css`
                  margin-top: 16px;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                `}
              >
                {submittedInfo?.billingInfo.map((billing, index) => {
                  if (billing.payment_type !== 'deposit') {
                    if (!submittedInfo?.singlePayment) {
                      return (
                        <div
                          key={billing?.uid}
                          css={css`
                            display: flex;
                            align-items: center;
                            margin: 6px 0;
                          `}
                        >
                          <div
                            css={css`
                              flex: 1;

                              @media (max-width: 768px) {
                                flex: 0;
                              }
                            `}
                          />
                          <p
                            css={css`
                              font-size: 16px;
                              font-style: normal;
                              font-weight: 700;
                              flex: 0.9;
                              color: ${isDarkMode ? colors.WHITE : '#27303e'};

                              @media (max-width: 768px) {
                                flex: 1;
                              }
                            `}
                          >
                            Payment {index}
                          </p>
                          <p
                            css={css`
                              margin-left: 16px;
                              font-size: 16px;
                              font-style: normal;
                              font-weight: 500;
                              color: ${isDarkMode ? colors.WHITE : '#27303e'};
                              flex: 2;

                              @media (max-width: 768px) {
                                flex: 1;
                              }
                            `}
                          >
                            {i18n.formatCurrency(billing?.subtotal, {
                              currency: submittedInfo?.currency?.name,
                              form: 'short',
                            })}{' '}
                            due{' '}
                            {dayjs(billing?.due_date).format('MMM DD, YYYY')}
                          </p>
                          <div
                            css={css`
                              flex: 1;

                              @media (max-width: 768px) {
                                flex: 0;
                              }
                            `}
                          />
                        </div>
                      )
                    }

                    return null
                  }
                })}
              </div>
            </div>
            {!submittedInfo?.singlePayment &&
              submittedInfo?.billingInfo &&
              submittedInfo?.billingInfo.length > 0 && (
                <div
                  css={css`
                    margin-top: 16px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    gap: 8px;
                    text-align: center;
                  `}
                >
                  <p
                    css={css`
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 500;
                      color: ${colors.ATTENDANCE_GRAY};
                    `}
                  >
                    You will be automatically charged on the above payment dates
                    via your payment method on file.
                  </p>
                </div>
              )}
          </>
        )}
    </div>
  )
})
